import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Identity20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10 7.25C11.4978 7.25 12.75 8.50217 12.75 10C12.75 10.8872 12.3056 11.7409 11.5812 12.25C12.4771 12.25 13.4394 12.428 14.0625 13.1273C14.7687 13.92 14.75 15.0028 14.75 16H13.25C13.25 15.4054 13.3649 14.5993 12.9425 14.1252C12.7861 13.9496 12.4641 13.769 11.6911 13.75H8.3C7.532 13.75 7.21476 13.9315 7.06054 14.1067C6.63662 14.5884 6.75 15.3985 6.75 16H5.25C5.25 15 5.23197 13.9141 5.93446 13.1158C6.56281 12.4018 7.51567 12.25 8.41884 12.25C7.69442 11.7409 7.25 10.8872 7.25 10C7.25 8.50217 8.50217 7.25 10 7.25ZM10 8.75C9.31917 8.75 8.75 9.31917 8.75 10C8.75 10.6808 9.31917 11.25 10 11.25C10.6808 11.25 11.25 10.6808 11.25 10C11.25 9.31917 10.6808 8.75 10 8.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7 0.25C6.58579 0.25 6.25 0.585786 6.25 1V1.25H2.5C1.80964 1.25 1.25 1.80965 1.25 2.5V18.5C1.25 19.1904 1.80964 19.75 2.5 19.75H17.5C18.1904 19.75 18.75 19.1904 18.75 18.5V2.5C18.75 1.80964 18.1904 1.25 17.5 1.25H13.75V1C13.75 0.585786 13.4142 0.25 13 0.25H7ZM13.75 2.75V4C13.75 4.41421 13.4142 4.75 13 4.75H7C6.58579 4.75 6.25 4.41421 6.25 4V2.75H2.75V18.25H17.25V2.75H13.75ZM7.75 3.25V1.75H12.25V3.25H7.75Z'
      fill='currentColor'
    />
  </Svg>
);

Identity20.displayName = 'Identity20';
export default Identity20;
